import { combineEpics } from 'redux-observable';
import { epic as authEpics } from './modules/auth';
import { epic as dataEpics } from './modules/data';
import { epic as driveEpics } from './modules/drive';

export const rootEpic = combineEpics(...authEpics, ...dataEpics, ...driveEpics);
